import { Form, FormField } from "@babackapp/ui/components/form";
import FormTagsInput from "@babackapp/react-hook-forms-components/form-tags-input";
import { SettingsFormPageButtonBar } from "@babackapp/react-hook-forms-components/form-page";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  PortalRefundFormSchema,
  PortalRefundFormValues,
} from "./portal-refund-card";
import useTranslation from "@babackapp/translations/use-translation";

type PortalRefundFormProps = {
  defaultValues?: Partial<PortalRefundFormValues>;
  onSubmit: (data: PortalRefundFormValues) => void;
};

export default function PortalRefundForm({
  onSubmit,
  defaultValues,
}: PortalRefundFormProps) {
  const t = useTranslation();

  const form = useForm<PortalRefundFormValues>({
    resolver: zodResolver(PortalRefundFormSchema),
    defaultValues: {
      tagsForNotAcceptedRefund: [],
      ...defaultValues,
    },
  });
  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col justify-start gap-8 mt-8"
      >
        <FormField
          control={form.control}
          name="tagsForNotAcceptedRefund"
          render={({ field }) => (
            <FormTagsInput
              label={t("settings.refund.tagsForNotAcceptedRefund.title")}
              description={t(
                "settings.refund.tagsForNotAcceptedRefund.description",
              )}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
        <SettingsFormPageButtonBar />
      </form>
    </Form>
  );
}
